<template>
  <div class="columns is-multiline">
    <div class="column">
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label" :for="beginId">Earliest</label>
        </div>
        <div class="field-body">
          <div class="field">
            <input
              :id="beginId"
              ref="beginInput"
              :value="begin"
              min="2011-01-01"
              :max="midnightTonight"
              placeholder=""
              class="input"
              :class="dateClassesForValue(begin)"
              type="date"
              @input="changed('begin', beginInput.value)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="column">
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label" :for="endId">Latest</label>
        </div>
        <div class="field-body">
          <div class="field">
            <input
              :id="endId"
              ref="endInput"
              :value="end"
              min="2011-01-01"
              :max="midnightTonight"
              placeholder=""
              class="input"
              :class="dateClassesForValue(end)"
              type="date"
              @input="changed('end', endInput.value)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="column is-narrow">
      <DateRangeMenu @update:model-value="(ev) => bothChanged(ev)" />
    </div>
  </div>
</template>

<script setup>import { ref as _ref, computed as _computed } from 'vue';

  import DateRangeMenu from "./date-range-menu.vue";

  import uniqid from "uniqid";
  import { format, endOfDay } from "date-fns";

  const props = defineProps({
    begin: { type: String, required: false, default: null },
    end: { type: String, required: false, default: null },
  });

  const emit = defineEmits(["update:model-value"]);

  /* LABEL for= identifiers */
  const [beginId, endId] = [uniqid(), uniqid()];

  const beginInput = _ref(null);
  const endInput = _ref(null);

  const midnightTonight = _computed(() => {
    return format(endOfDay(new Date()), "yyyy-MM-dd");
  });

  const dateClassesForValue = (value) => {
    return value ? ["has-value"] : [];
  };

  const changed = (key, value) => {
    const payload = { begin: props.begin, end: props.end };
    payload[key] = value;

    emit("update:model-value", payload);
  };

  const bothChanged = ({ begin, end }) => {
    emit("update:model-value", { begin, end });
  };
</script>

<style lang="scss" scoped>
  @import "~jose_modern/css";

  input[type="date"]:invalid {
    border-color: $danger;
  }

  input[type="date"]:valid {
    &.has-value {
      border-color: $success;
    }
  }
</style>
